<div [@slideAnimation]="slide">
  <ng-content></ng-content>
</div>
